var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_802_4644",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 9,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21644 0.760556C2.90287 1.06565 2.90287 1.56029 3.21644 1.86538L8.00159 6.52118L3.21644 11.177C2.90287 11.4821 2.90287 11.9767 3.21644 12.2818C3.53 12.5869 4.0384 12.5869 4.35196 12.2818L10.2726 6.52118L4.35196 0.760556C4.0384 0.455466 3.53 0.455466 3.21644 0.760556Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_802_4644)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.377258,
    y: 0.270264,
    width: 12.4995,
    height: 12.4997,
    fill: "#1F2024"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/detail.ce7e4558671816b0a7ff14b857223453.svg";
export { ForwardRef as ReactComponent };